import jwt_decode from "jwt-decode";

let token;

let configObject = {
  // apiBaseUrl: "https://www.epump.club",
  // apiBaseUrl: "https://oh.epump.com.ng",
  // apiBaseUrl: "https://api.epump.com.ng",
  pdfBaseUrl: "https://pdf.epump.cf",
  // apiBaseUrl: " https://apiv2.epump.ng",
  // apiBaseUrl: "https://testapi.epump.com.ng",
  // apiBaseUrl: "https://oh.epump.com.ng",

  // apiBaseUrl: "https://ta.epump.com.ng",
  // apiBaseUrl: "https://to.epump.com.ng",
  // apiBaseUrl: "https://tg.epump.com.ng",

  apiBaseUrl: "https://altapi.epump.com.ng",

  remisBaseUrl: "https://api.remis.africa",

  authConfig: configObjectFunc,
  authConfigForUpload: configObjectForUploadFunc,
  remisConfig: remisHashConfig,

  posBaseUrl: "https://pos.remis.africa",
  devEmail: "dev_ep@siga.33mail.com",
  appId: "EPM_2B6B49D3D6524830A18E0449855301E1",
  secKey: "EPM_BA095_8B4F39374D8149E9829FC2F62F1B2FAD",
};

function configObjectFunc(isRemis) {
  if (localStorage.getItem("userDetails")) {
    token = JSON.parse(localStorage.getItem("userDetails")).token;
  } else {
    token = null;
  }

  if (token) {
    let exp;
    if (localStorage.getItem("jwtExpiry")) {
      exp = localStorage.getItem("jwtExpiry");
    } else {
      const decoded = jwt_decode(token);
      exp = decoded.exp * 1000;
    }

    const now = Date.now();
    if (now > exp) {
      localStorage.clear();
      if (window.location.origin !== window.location.href) {
        window.location.href = window.location.origin;
      }
    }

    const remisHash = JSON.parse(localStorage.getItem("rHash"));

    let header;

    if (isRemis && remisHash) {
      header = {
        // "Content-Type": "multipart/form-data",
        Authorization: "bearer " + token,
        Accept: "*/*",
        "ep-key": remisHash.key,
        "ep-hash": remisHash.hashKey,
      };
    } else {
      header = {
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
        Accept: "application/json",
      };
    }

    return {
      headers: header,
    };
  } else {
    return null;
  }
}
// function remisHashConfig() {
//   //pos hash parameters
//   let sha512 = require("js-sha512").sha512;
//   let devEmail = "dev_ep@siga.33mail.com";
//   let appId = "EPM_2B6B49D3D6524830A18E0449855301E1";
//   let secKey = "EPM_BA095_8B4F39374D8149E9829FC2F62F1B2FAD";
//   let hash = `${secKey}-${devEmail}-${appId}`;

//   const newHeader = {
//     ...configObject.authConfig().headers,
//     appId,
//     request_hash: sha512(hash.toLowerCase()),
//   };

//   let config = {
//     headers: newHeader,
//   };
//   return config;
// }

function remisHashConfig(arg) {
  let isRemis;
  if (arg) {
    isRemis = arg.isRemis;
  } else {
    isRemis = false;
  }
  //pos hash parameters
  let sha512 = require("js-sha512").sha512;
  let devEmail = "dev_ep@siga.33mail.com";
  let appId = "EPM_2B6B49D3D6524830A18E0449855301E1";
  let secKey = "EPM_BA095_8B4F39374D8149E9829FC2F62F1B2FAD";
  let remisHash =
    "8617D31DC0AA4CD8F4BAE908C2170D381D31D801D0A8D4682C972BB2D62DECC544D7DBC9F2F67B5D443772AFFB3868DB27A9F875BD96F21F4FBE504632F3596A";
  let hash = `${secKey}-${devEmail}-${appId}`;
  let newHeader;

  if (isRemis) {
    newHeader = {
      // "Content-Type": "multipart/form-data",
      Accept: "*/*",
      "ep-key": appId,
      "ep-hash": remisHash,
    };
  } else {
    newHeader = {
      ...configObject.authConfig().headers,
      appId,
      request_hash: sha512(hash.toLowerCase()),
    };
  }
  // console.log(newHeader, sha512(hash.toLowerCase()), "header");
  let config = {
    headers: newHeader,
  };
  return config;
}

function configObjectForUploadFunc() {
  if (localStorage.getItem("userDetails")) {
    token = JSON.parse(localStorage.getItem("userDetails")).token;
  } else {
    token = null;
  }

  if (token) {
    let exp;
    if (localStorage.getItem("jwtExpiry")) {
      exp = localStorage.getItem("jwtExpiry");
    } else {
      const decoded = jwt_decode(token);
      exp = decoded.exp * 1000;
    }

    const now = Date.now();
    if (now > exp) {
      localStorage.clear();
      if (window.location.origin !== window.location.href) {
        window.location.href = window.location.origin;
      }
    }

    return {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "bearer " + token,
        Accept: "*/*",
      },
    };
  } else {
    return null;
  }
}

export default configObject;
